import React, { useEffect } from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { Auth, Hub } from "aws-amplify";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import AuthFlow from "./AuthFlow";
import {
  setAuthStatus,
} from "../../redux/reducers/authentication/AuthReducer";
import Cookies from "js-cookie";

function AppAuth({ children, setAuthStatusFromProps }) {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const navigate = useNavigate();

  useEffect(() => {
    setAuthStatusFromProps(authStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStatus]);

  // Restore the deep link the user arrived on before an SSO round-trip. On
  // federated sign-in we stash the intended path+query as Amplify `customState`
  // (see Signin.handleSsoSignIn); Amplify delivers it back here via the
  // `customOAuthState` Hub event once the OAuth callback completes. AppAuth is
  // always mounted inside the Router, so the listener is registered before the
  // event fires. Navigating (SPA) preserves the query string so the deep-link
  // resolver still gets ?type=/&date=.
  useEffect(() => {
    const unsubscribe = Hub.listen("auth", ({ payload }) => {
      if (payload?.event === "customOAuthState" && payload.data) {
        try {
          const target = decodeURIComponent(payload.data);
          if (target && target.startsWith("/")) {
            navigate(target, { replace: true });
          }
        } catch (e) {
          /* ignore a malformed customState — land on the default page */
        }
      }
    });
    return () => {
      // Hub.listen returns an unsubscribe fn (Amplify v5); guard for safety.
      if (typeof unsubscribe === "function") unsubscribe();
    };
  }, [navigate]);

  async function getUsername() {
    // const username = await Auth.currentUserInfo();
  }

  if (authStatus === "configuring") {
    getUsername();
  }

  if (authStatus === "authenticated") {
    getUsername();
    return <>{children}</>;
  } else if (authStatus === "configuring") {
    return <></>;
  } else {
    return <AuthFlow />;
  }
}

const authStateToProps = (state) => {
  // console.log(state.auth.authStatus);
  return {
    authState: state.auth.authStatus,
  };
};

const authStatusDispatchToProps = (dispatch) => {
  return {
    setAuthStatusFromProps: (authStatus) => dispatch(setAuthStatus(authStatus)),
  };
};

export default connect(authStateToProps, authStatusDispatchToProps)(AppAuth);
